<template>
  <form action="">
    <div class="modal-card" style="width: 500px">
      <header class="modal-card-head">
        <p class="modal-card-title">Intro Card</p>
        <button
            class="delete"
            type="button"
            @click="$emit('close')"/>
      </header>
      <section class="modal-card-body">
        <b-field label="Title">
          <b-input
              v-model="cardTitle"
              required
              type="text">
          </b-input>
        </b-field>

        <b-field label="Text 1">
          <b-input
              v-model="cardBody"
              required
              type="textarea"
          >
          </b-input>
        </b-field>

        <b-field label="Image URL">
          <b-input
              v-model="cardImgUrl"
          >
          </b-input>
        </b-field>

        <b-field label="Text 2">
          <b-input
              v-model="cardText2"
              required
              type="textarea"
          >
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button
            label="Close"
            @click="$emit('close')"/>
        <b-button
            label="Save"
            type="is-primary"
            @click="saveCard"/>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  name: 'CardForm',

  props: {
    card: {},
    isEdit: false,
  },
  data() {
    return {
      cardTitle: '',
      cardBody: '',
      cardImgUrl: '',
      cardText2: '',
    }
  },
  created() {
    if (this.isEdit) {
      this.cardTitle = this.card.title
      this.cardBody = this.card.body
      this.cardImgUrl = this.card.imgUrl
      this.cardText2 = this.card.text2
    }
  },
  methods: {
    saveCard() {
      const card = {
        title: this.cardTitle,
        body: this.cardBody,
        imgUrl: this.cardImgUrl,
        text2: this.cardText2
      }

      this.$emit('save', card)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
